/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import Backdrop from "@mui/material/Backdrop";
import Typography from "@mui/material/Typography";
import React from "react";

export default function ErrorMessage(props) {
  const { status } = props;
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open
    >
      <Typography variant='h4' color='#77b900'>
        {status === 401 && (
          <>Your session has expired, please refresh to start a new one.</>
        )}
        {status === 503 && (
          <>All bots are busy helping other people, please come back later.</>
        )}
        {status === 400 && (
          <>
            Invalid token, please clear the browser cookie and refresh the page.
          </>
        )}
        {status === 403 && (
          <>Unable to validate session, please contact Nvidia</>
        )}
        {status === "vst-websocket-error" && (
          <>Unable to connect, please come back later</>
        )}
      </Typography>
    </Backdrop>
  );
}
